import {
  AttachMoney,
  GroupWork,
  Person,
  PlaylistAddCheck,
  TrendingUp,
} from '@mui/icons-material';
import * as React from 'react';

import { IndicatorCategory } from '~/services/Http';

export interface Props {
  category: IndicatorCategory;
}

export const CategoryIconFormatter: React.FC<Props> = ({ category }) => {
  const lowerCaseTitle = category.toLowerCase();

  switch (lowerCaseTitle) {
    case IndicatorCategory.PEOPLE.toLowerCase():
      return <Person />;
    case IndicatorCategory.REWARDING.toLowerCase():
      return <AttachMoney />;
    case IndicatorCategory.PERFORMANCE.toLowerCase():
      return <PlaylistAddCheck />;
    case IndicatorCategory.DEVELOPMENT.toLowerCase():
      return <TrendingUp />;

    default:
      return <GroupWork />;
  }
};
